import {BaseTile, TileType} from './BaseTile';

export class WaterTile extends BaseTile {
    type = TileType.water;
    sprite = '/assets/siccinct/tiles/water.png';

    animation = {duration: 1.8, steps: 8};
}